import React, {useContext, useEffect} from "react";
import {useNavigate} from "@/components/helpers/routerCompat";
import {AbilityContext} from "./Can";
import {useOrgPath} from "./OrgNavLink";

// Wraps Manage page content. Redirects to the org home if the current user
// lacks the given ability. Default gate is view_manage_menu/Organization
// (admin / global_content / global_library).
export default function ManageGuard({action = 'view_manage_menu', subject = 'Organization', children}) {
    const ability = useContext(AbilityContext);
    const navigate = useNavigate();
    const orgPath = useOrgPath();

    // Abilities load asynchronously after the org-find API call returns, so on
    // the very first render `ability.rules` is empty and `can(...)` returns
    // false even for admins. Wait for rules to populate before deciding to
    // redirect — otherwise admins hitting a Manage URL directly bounce to home
    // before the page has a chance to mount.
    const abilitiesLoaded = (ability?.rules?.length || 0) > 0;
    const allowed = abilitiesLoaded && !!ability.can(action, subject);

    useEffect(() => {
        if (abilitiesLoaded && !allowed) navigate(orgPath('/'), {replace: true});
    }, [abilitiesLoaded, allowed]);

    if (!allowed) return null;
    return children;
}
